import { defineComponent } from 'vue';
export default defineComponent({
    name: 'Selector',
    props: {
        modelValue: {
            type: [String, Number],
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        size: {
            type: String,
            required: false,
            default: ''
        },
        defaultText: {
            type: String,
            required: false,
            default: 'Select an option'
        }
    },
    computed: {
        classes() {
            const classList = ['form-select'];
            if (this.size)
                classList.push(`form-select-${this.size}`);
            return classList;
        },
        isModelValueValid() {
            return this.options.some(option => option.value === this.modelValue);
        }
    },
    methods: {
        onChange(event) {
            event.stopPropagation();
            if (event.target instanceof HTMLSelectElement) {
                this.$emit('change', event.target.value);
            }
        },
        onInput(event) {
            event.stopPropagation();
            if (event.target instanceof HTMLSelectElement) {
                this.$emit('update:modelValue', event.target.value);
            }
        }
    }
});
